document.querySelectorAll('.js-smooth-scroll').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        if (!targetId) return;

        if (!targetId.startsWith('#')) {
            sessionStorage.setItem(
                'scrollToAnchor',
                targetId.split('#')[1] ? '#' + targetId.split('#')[1] : ''
            );
            window.location.href = targetId;
            return;
        }

        const targetElement = document.querySelector(targetId);
        const mdlWrap = this.closest('.mdl-wrap');
        if (mdlWrap) {
            mdlWrap.classList.remove('active');
            if (typeof overlayEnd === 'function') overlayEnd();
            setTimeout(() => {
                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop - 96,
                        behavior: 'smooth',
                    });
                }
            }, 300);
        } else {
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 96,
                    behavior: 'smooth',
                });
            }
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const anchor = sessionStorage.getItem('scrollToAnchor');
    if (anchor) {
        setTimeout(() => {
            const targetElement = document.querySelector(anchor);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });

                window.scrollBy(0, -96);
            }
            sessionStorage.removeItem('scrollToAnchor');
        }, 100);
    }
});
